import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class Tibbit_14 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_14';
        this.name = 'Tibbit 14';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt14/tbt14.tbh',
            'libraries/tibbits/tbt14/tbt14.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                default: '',
            },
            {
                id: 'CH1',
                name: 'Channel 1',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: '',
            },
            {
                id: 'CH2',
                name: 'Channel 2',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: '',
            },
            {
                id: 'CH3',
                name: 'Channel 3',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: '',
            },
            {
                id: 'CH4',
                name: 'Channel 4',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: '',
            },
            {
                id: 'USESSI',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                readonly: true,
                default: 'NO',
                options: [
                    {
                        name: 'I2C mode',
                        value: 'YES',
                    },
                    {
                        name: 'Direct I/O (bit-banging)',
                        value: 'NO',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);
        const NAME = this.getSettingValue('NAME');
        const CH1 = this.getSettingValue('CH1');
        const CH2 = this.getSettingValue('CH2');
        const CH3 = this.getSettingValue('CH3');
        const CH4 = this.getSettingValue('CH4');
        const USESSI = this.getSettingValue('USESSI');

        const varCH1 = this.project.getVariableByName(CH1);
        const varCH2 = this.project.getVariableByName(CH2);
        const varCH3 = this.project.getVariableByName(CH3);
        const varCH4 = this.project.getVariableByName(CH4);

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 14 setup on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    tbt14_init("${NAME}",${NAME}_DATA,${NAME}_CLK,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM,${USESSI})
    
    'To set DAC outputs:
    'tbt14_set_mv(DAC_1,-9500,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)    '-9.50V
    'tbt14_set_mv(DAC_2,-5000,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)    '-5.00V
    'tbt14_set_mv(DAC_3,1250,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)     '+1.25V
    'tbt14_set_mv(DAC_4,7000,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)     '+7.00V

    var_${CH1}_set(${varCH1.getSettingValue('DEFAULT')})
    var_${CH2}_set(${varCH2.getSettingValue('DEFAULT')})
    var_${CH3}_set(${varCH3.getSettingValue('DEFAULT')})
    var_${CH4}_set(${varCH4.getSettingValue('DEFAULT')})
    '-----------------------------------------------------------------

        `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME}_CHANNEL_NUM as byte
        `,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME}_CHANNEL_NUM as byte
        `,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${NAME}_CLK=${socket?.pins[0]}
const ${NAME}_DATA=${socket?.pins[1]}
const ${NAME}_LOAD=${socket?.pins[2]}
const ${NAME}_BUSY=${socket?.pins[3]}`,
        });

        blocks.push({
            location: `var_${CH1}_set`,
            blockType: BlockType.LOCATION,
            template: `tbt14_set_mv(DAC_1,value * 1000,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)`,
        });
        blocks.push({
            location: `var_${CH2}_set`,
            blockType: BlockType.LOCATION,
            template: `tbt14_set_mv(DAC_2,value * 1000,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)`,
        });
        blocks.push({
            location: `var_${CH3}_set`,
            blockType: BlockType.LOCATION,
            template: `tbt14_set_mv(DAC_3,value * 1000,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)`,
        });
        blocks.push({
            location: `var_${CH4}_set`,
            blockType: BlockType.LOCATION,
            template: `tbt14_set_mv(DAC_4,value * 1000,${NAME}_LOAD,${NAME}_BUSY,${NAME}_CHANNEL_NUM)`,
        });

        return blocks;
    }
}
